import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { PATH_ROOT } from "@/routes/paths";

import { DealComparisonMainView } from "./DealComparisonMainView";
import { DealComparisonUploadView } from "./DealComparisonUploadView";

type Screen = "upload" | "page";

export default function AriDemoDealComparisonPage() {
  const navigate = useNavigate();
  const [screen, setScreen] = useState<Screen>("page");

  if (screen === "upload") {
    return (
      <div className="flex h-full min-h-0 flex-col">
        <DealComparisonUploadView
          onCancel={() => setScreen("page")}
          onComplete={() => setScreen("page")}
        />
      </div>
    );
  }

  return (
    <div className="flex h-full min-h-0 flex-col">
      <DealComparisonMainView
        onBack={() => navigate(PATH_ROOT.demo.selector)}
        onOpenUpload={() => setScreen("upload")}
      />
    </div>
  );
}
